/**
 * @file Newsletter Modal
 */

import { gsap } from 'gsap';

/**
 * Newsletter Modal component
 */
const vNewsletterModal = () => {
	const newsletterModal = document.querySelector('.v-newsletter-modal');

	if (!newsletterModal) {
		return;
	}

	const formWrap    = newsletterModal.querySelector('.v-newsletter-modal__form');

	/**
	 * Hide labels and other unnecessary elements
	 */
	const hideElements = () => {
		const willHide = formWrap.querySelectorAll('legend, #bboxsignup-dc8e0e1e-9818-4bf6-ac63-0f1e0651c6f0_lblHeadingSignup, legend + div.BBFormFieldContainer, [id$="_divPrivacyPolicy"]');
		[...willHide].forEach((el) => {
			el.classList.add('v-newsletter-modal__hide');
		});
	};

	/**
	 * Style the form
	 */
	const styleFieldset = () => {
		const fieldset   = formWrap.querySelector('fieldset');
		const inputRow   = formWrap.querySelector('[id$="_divFields"]');
		const inputWraps = inputRow.querySelectorAll('div.BBFormFieldContainer');
		const inputs     = inputRow.querySelectorAll('[type="text"], [type="email"]');
		const btnRow     = formWrap.querySelector('.BBFormButtonRow');
		const submit     = formWrap.querySelector('[id$="_btnSubmit"]');

		fieldset.classList.add('v-newsletter-modal__fieldset');
		inputRow.classList.add('v-newsletter-modal__input-row');
		[...inputWraps].forEach((wrap) => wrap.classList.add('v-newsletter-modal__input-wrap'));
		[...inputs].forEach((input) => input.classList.add('v-newsletter-modal__input'));
		btnRow.classList.add('v-newsletter-modal__btn-row');
		submit.classList.add('v-button', 'v-newsletter-modal__submit');
	};

	/**
	 * Add relevant event listeners
	 */
	const addListeners = () => {
		const inputs     = formWrap.querySelectorAll('[id$="_divFields"] [type="text"], [id$="_divFields"] [type="email"]');

		[...inputs].forEach((input) => {
			input.addEventListener('input', () => {
				if (input.value) {
					input.classList.add('v-newsletter-modal__input--active');
				} else {
					input.classList.remove('v-newsletter-modal__input--active');
				}
			});
		});
	};

	/**
	 * Runs on form init
	 */
	const formInit    = () => {
		hideElements();
		styleFieldset();
		addListeners();
	};

	if (formWrap) {
		window.bboxInit2 = window.bboxInit2 || [];
		window.bboxInit2.push(() => {
			bboxApi.showForm('c5ac270d-80d0-4d00-bb91-9c6d8506c0f1'); // eslint-ignore-line
		});
		(function () {
			const e = document.createElement('script');
			e.async = true;
			e.src   = 'https://bbox.blackbaudhosting.com/webforms/bbox-2.0-min.js';
			document.getElementsByTagName('head')[0].appendChild(e);
		}());

		const targetNode = document.querySelector('head');
		const config     = {
			childList: true,
		};
		const callback   = function (mutationsList, observer) {
			const addedStyles = document.querySelectorAll('link[rel="stylesheet"][href^="https://bbox.blackbaudhosting.com"]');
			for (let i = 0; i < addedStyles.length; i++) {
				addedStyles[i].parentNode.removeChild(addedStyles[i]);
			}

			if (addedStyles.length) {
				observer.disconnect();
			}
		};

		const observer = new MutationObserver(callback);
		observer.observe(targetNode, config);

		/**
		 * Callback to run init function or denote user signed up for emails
		 */
		const emailFormCb  = () => {
			const field        = formWrap.querySelector('input[type="text"]');
			const confirmation = formWrap.querySelector('.BBFormSection > p');
			if (field) {
				formInit();
				formWrap.setAttribute('data-loaded', '');
			} else if (confirmation && confirmation.textContent.indexOf('Thank you for signing up') >= 0) {
				formWrap.setAttribute('data-signed-up', 'true');
			}
		};

		const formObserver = new MutationObserver(emailFormCb);
		formObserver.observe(formWrap, config);
	}

	const closeButton = newsletterModal.querySelector('.v-newsletter-modal__close');
	const modal = newsletterModal.querySelector('.v-newsletter-modal__modal');
	const inner = newsletterModal.querySelector('.v-newsletter-modal__inner');
	const bg    = newsletterModal.querySelector('.v-newsletter-modal__bg');
	let isAnimating = false;

	/**
	 * Close modal
	 */
	const closeModal = () => {
		if (newsletterModal.getAttribute('data-open') === 'false' || isAnimating) {
			return;
		}

		// gsap.to()
		gsap.timeline({
			defaults: {
				ease:     'ease.out',
				duration: 0.5,
			},
			onStart: () => {
				isAnimating = true;
			},
			onComplete: () => {
				newsletterModal.setAttribute('data-open', 'false');
				modal.removeAttribute('style');
				isAnimating = false;
			},
		})
			.to(closeButton, { opacity: 0 })
			.to(inner, { opacity: 0 }, '>-.1')
			.to(modal, { opacity: 0, y: '100%' }, '>-.1')
			.to(bg, { opacity: 0 }, '>-.1');
	};

	closeButton.addEventListener('click', closeModal);
	bg.addEventListener('click', closeModal);

	const modalObserver = new MutationObserver((list) => {
		list.forEach((mutation) => {
			if (
				mutation.type === 'attributes'
				&& mutation.attributeName === 'data-open'
				&& mutation.target.getAttribute('data-open') === 'trigger'
			) {
				//open the modal
				if (isAnimating) {
					return;
				}

				gsap.timeline({
					defaults: {
						ease:     'ease.out',
						duration: 0.5,
					},
					onStart: () => {
						isAnimating = true;
						const trigger        = document.querySelector('[data-trigger="true"]');

						trigger.setAttribute('data-trigger', 'false');

						if (!formWrap.hasAttribute('data-loaded')) {
							return;
						}

						const emailAddress   = trigger.querySelector('input[type="email"]');

						if (emailAddress.value) {
							const modalEmail     = formWrap.querySelector('input[type="email"]');
							modalEmail.value     = emailAddress.value;
							modalEmail.classList.add('v-newsletter-modal__input--active');
						}
					},
					onComplete: () => {
						newsletterModal.setAttribute('data-open', 'true');
						isAnimating = false;
					}
				})
					.to(bg, { opacity: .75 })
					.to(modal, { opacity: 1, y: '-50%' }, '<')
					.to(inner, { opacity: 1 }, '>-.1')
					.to(closeButton, { opacity: 1 }, '>-.1');
			}
		});
	});
	modalObserver.observe(newsletterModal, {
		attributes: true,
	});
};

export default vNewsletterModal;
